import {useState, useEffect} from "react";

const useMedia = query => {
  const mediaQueryList = window.matchMedia(query);
  const [matches, setMatches] = useState(mediaQueryList.matches);

  useEffect(() => {
    let mounted = true;

    const updateMatches = event => setMatches(event.matches);

    if (mounted) {
      mediaQueryList.addListener(updateMatches);
    }

    return () => {
      mounted = false;
      mediaQueryList.removeListener(updateMatches);
    };
  }, [query]);

  return matches;
};

export default useMedia;
